import { useEffect, useRef } from 'react';
import { NextRouter } from 'next/router';

import { parseQueryString } from '../helpers/parseQueryString';
import {
  addSessionPreviousPage,
  setSessionLandingPage,
  setTrackingIdentifiers,
} from '../modules/session';

export const useSession = ({ asPath }: Pick<NextRouter, 'asPath'>) => {
  const previousPage = useRef<string | null>(null);

  useEffect(() => {
    if (previousPage.current === null) {
      previousPage.current = document.referrer ?? '';
    }

    addSessionPreviousPage(previousPage.current);
    setSessionLandingPage(window.location.href);
    setTrackingIdentifiers(parseQueryString(asPath));

    previousPage.current = asPath;
  }, [asPath]);
};
